import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconClose(props: SvgIconProps) {
  return (
    <SVGIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2.46436 2.46448L9.53542 9.53555" stroke="currentColor" />
      <path d="M2.46436 9.53552L9.53542 2.46445" stroke="currentColor" />
    </SVGIcon>
  );
}
